import { library } from '@fortawesome/fontawesome-svg-core'

import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart'
import { faCartArrowDown } from '@fortawesome/pro-solid-svg-icons/faCartArrowDown'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faSignInAlt } from '@fortawesome/pro-solid-svg-icons/faSignInAlt'
import { faCubes } from '@fortawesome/pro-solid-svg-icons/faCubes'
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard'
import { faUniversalAccess } from '@fortawesome/pro-solid-svg-icons/faUniversalAccess'
import { faChartNetwork } from '@fortawesome/pro-solid-svg-icons/faChartNetwork'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'

library.add(
  faShoppingCart, faCartArrowDown, faTimes, faSignInAlt, faCubes, faCreditCard, faUniversalAccess, faChartNetwork,
  faExclamation, faExclamationTriangle
)
